"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Angle = void 0;
class Angle {
    constructor(degrees) {
        this._degrees = 0;
        this._degrees = degrees;
    }
    /**
     * Creates an angle from degrees
     * @param degrees Angle in degrees
     * @returns The angle
     */
    static FromDegrees(degrees) {
        return new Angle(degrees);
    }
    /**
     * Creates an angle from radians
     * @param radians Angle in radians
     * @returns The angle
     */
    static FromRadians(radians) {
        return new Angle((radians * 180) / Math.PI);
    }
    /**
     * Check to see if two angles are close
     * @param a Angle A
     * @param b Angle B
     * @param tolerance Tolerance for "Close" in degrees. Defaults to 0.001;
     * @returns True if the difference between A and B (in degress) is less than the tolerance
     */
    static Close(a, b, tolerance = 0.001) {
        let diff = a.degrees - b.degrees;
        if (diff < 0) {
            diff = -diff;
        }
        return diff < tolerance;
    }
    get degrees() {
        return this._degrees;
    }
    get radians() {
        return (this._degrees * Math.PI) / 180;
    }
}
exports.Angle = Angle;
